<section class="pad">
  <br /><br />

  <div class="sMbdrRad mat-elevation-z8">
    <div *ngIf="openCoverExpiry" class="openCover1">
      ! Your open cover window has expired or disabled, kindly do a reconciliation or contact admin to enable it. 
  </div>
    <div class="filter-wrapper">
      <h3>Filter</h3>
      <br />
      <div>
        <form [formGroup]="transFilter" class="filter">
          <div>
            <!-- <mat-form-field appearance="outline">
              <mat-label>Pick Date</mat-label>
              <input
                formControlName="date"
                [min]="minDate"
                matInput
                [matDatepicker]="pickerStart"
              />
              <mat-hint>MM /DD/YYYY</mat-hint>
              <mat-datepicker-toggle
                matIconSuffix
                [for]="pickerStart"
              ></mat-datepicker-toggle>
              <mat-datepicker #pickerStart></mat-datepicker>
            </mat-form-field> -->

            <mat-form-field appearance="outline">
                <mat-label>Enter a date range</mat-label>
                <mat-date-range-input [formGroup]="transFilter" [rangePicker]="picker">
                  <input formControlName="startDate" matStartDate placeholder="Start date">
                  <input formControlName="endDate" matEndDate (dateChange)="dateRange()" placeholder="End date">
                </mat-date-range-input>
                <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>

                <button mat-icon-button (click)="reset()" *ngIf="cancel" id="cancel"> <mat-icon> cancel </mat-icon></button>
              </mat-form-field>
          </div>

          <!-- <mat-form-field appearance="outline">
            <mat-label>Status Sort</mat-label>
            <mat-select
              formControlName="sortStatus"
              (selectionChange)="sortStatus()"
            >
              <mat-option style="font-size: 1.2rem; font-weight: bold;" *ngFor="let sort of sanctionedStatus" [value]="sort.value">{{sort.viewValue}}</mat-option>
            </mat-select>
          </mat-form-field> -->

          <!-- <div>
            <mat-form-field appearance="outline">
              <mat-label>Phone Number</mat-label>
              <input formControlName="phone" matInput />
              <mat-error *ngIf="transFilter.controls.phone.errors">Incorrect Phone Number</mat-error>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field appearance="outline">
              <mat-label>Passport Number</mat-label>
              <input formControlName="passport" matInput />
              <mat-error *ngIf="transFilter.controls.passport.errors">Incorrect Passport Number</mat-error>
            </mat-form-field>
          </div> -->
        </form>
        <br />
        <!-- <button mat-raised-button color="primary" (click)="filter()">Filter</button> -->
      </div>
    </div>

    <br /><br />

    <div class="flex" style="justify-content: space-between">
      <h3 style="padding-left: 10px">All Transactions</h3>
      <button mat-button (click)="export()">Export</button>
    </div>

    <div class="bulk-button" *ngIf="showButtons">
      <!-- <button
        class="execute_button"
        type="button"
        (click)="reconcile()"
      >
        <mat-icon style="color: #fff;">done_all</mat-icon>
        Pay
        
      </button> -->
      <button color="warn" mat-stroked-button (click)="upload('2000ms', '1000ms')">
        <mat-icon style="color: var(--primary-color);">done_all</mat-icon>
        Reconcile Polic(ies) 
        {{ selectedRows.length }}
      </button>
      <p *ngIf="user['role'] == 'staff'" style="font-size: 1.3em;">Total Gross Premium to be Paid: <span style="color: #ee3123; font-size: 1.3em;">{{totalGrossPrice | currency: '₦ '}}</span> </p>
      <p *ngIf="user['role'] == 'broker'" style="font-size: 1.3em;">Total Net Premium to be Paid: <span style="color: #ee3123; font-size: 1.3em;">{{totalNetPrice | currency: '₦ '}}</span> </p>
    </div>

    <table mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="select" sticky>
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? toggleAllRows() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="row.type === 'units' && row.reconciled === 'Not Started'">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              (change)="logRowData(row)"
              (change)="AllButton()"
              [checked]="selection.isSelected(row)"
            >
            </mat-checkbox>
          </ng-container>
        </td>
      </ng-container>
   
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Initiator</th>
        <td mat-cell *matCellDef="let element">{{ element.email }}</td>
      </ng-container>

      <ng-container matColumnDef="commission">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          {{ element.commission | currency : "₦ " }}
        </td>
      </ng-container>
      <ng-container matColumnDef="netPrice">
        <th mat-header-cell *matHeaderCellDef class="netPrice">Net Price</th>
        <td mat-cell *matCellDef="let element" class="netPrice">
          {{ element.netPrice | currency : "₦ " }}
        </td>
      </ng-container>

      <ng-container matColumnDef="grossPrice">
        <th mat-header-cell *matHeaderCellDef class="gross">Gross</th>
        <td mat-cell *matCellDef="let element" class="gross">
          {{ element.grossPrice | currency : "₦ " }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="status">Status</th>
        <td mat-cell *matCellDef="let element" class="status">
          {{ element.status | titlecase }}
        </td>
      </ng-container>

      <ng-container matColumnDef="reconcile">
        <th mat-header-cell *matHeaderCellDef class="reconcile">Reconcile</th>
        <td mat-cell *matCellDef="let element" class="reconcile"
        [ngClass]="{
          'reconcile-not-started': element?.reconciled === 'Not Started',
          'reconcile-pending': element?.reconciled === 'Pending',
          'reconcile-confirmed': element?.reconciled === 'Confirmed',
          'reconcile-rejected': element?.reconciled === 'Rejected'
        }"
        >
          {{ element?.reconciled || 'N/A' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="updated_at">
        <th mat-header-cell *matHeaderCellDef class="date">Date</th>
        <td mat-cell *matCellDef="let element" class="date">
          {{ element.updated_at | date : "medium" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="policy_detail_id">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let element">
          <a
            routerLink="../policy-details/{{ element.policy_detail_id }}"
            mat-button
            >View Details</a
          >
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

  </div>

</section>
